import { render, staticRenderFns } from "./ElevatorTroubleLogTable.vue?vue&type=template&id=437b42c8"
import script from "./ElevatorTroubleLogTable.vue?vue&type=script&script=true&setup=true&lang=js"
export * from "./ElevatorTroubleLogTable.vue?vue&type=script&script=true&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
